import { CardModificationDTO } from '@src/adapters/dto/card/CardModificationDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  cardId: string;
  itemId: string;
}

interface Result {
  modification: CardModificationDTO;
}

const options: ApiOptions = {
  method: 'delete',
  urlPath: '/card/delete_item',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useDeleteCardItemLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useDeleteCardItemLazy;
